import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { environment } from '../../../../environments/environment';

/** Central logo per build — see `AuthLayoutComponent`'s `AUTH_LOGOS` and
 *  `SidebarComponent.LOGOS` for the equivalent maps driving the login screen's brand
 *  panel and the signed-in app shell's sidebar logo (each keeps its own copy — their
 *  fallback-on-unknown-brand semantics aren't identical, see `environment.util.ts`). */
const LOGOS: Record<string, { src: string; alt: string }> = {
  plusphysio:    { src: '/assets/plus_physio_Logo.png',    alt: 'PlusPhysio' },
  plusdoctor:    { src: '/assets/plus_doctor_logo.png',    alt: 'PlusDoctor' },
  plusradiology: { src: '/assets/plus_radiology_logo.png', alt: 'PlusRadiology' },
  pluspedia:     { src: '/assets/plus_pedia_logo.png',    alt: 'PlusPedia' },
  plusgynecologist: { src: '/assets/plus_gynecologist_logo.png', alt: 'PlusGynaecologist' },
};

/**
 * Full-screen loading overlay with a pulsing concentric-ring animation and a
 * rotating brand arc around a central "+" mark. Renders only while `show()` is
 * true; dims the background behind it.
 */
@Component({
  selector: 'app-loader',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {
  /** Toggles the overlay on/off. */
  readonly show = input<boolean>(false);

  /** Optional line shown under the animation (e.g. "Loading images... 120 / 788"). Empty shows none. */
  readonly message = input<string>('');

  /** Central logo for the running build; unrecognised brands fall back to PlusPhysio's. */
  readonly logo = LOGOS[environment.environmentName] ?? LOGOS['plusphysio'];
}
